import React from "react";
import { Box, Card, CardContent, Typography, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import LoopIcon from "@mui/icons-material/Loop";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { CustomPalette } from "../constants/customPalette";

const LandingDropZone = ({
  loading,
  dropDisabled,
  spinningAnimation,
  getRootProps,
  getInputProps,
  handleHover,
  handleHoverLeave,
  handleDragOver,
  handleDragLeave
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center"
        }}
        {...getRootProps({ className: "dropzone" })}
      >
        <input {...getInputProps()} />
        <Card
          sx={{
            border: 1,
            padding: "8px",
            paddingLeft: "20px",
            paddingRight: "20px",
            height: "80px",
            width: "300px",
            marginTop: 3,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#CDCDCD",
            alignSelf: "center",
            cursor: "pointer"
          }}
          onMouseOver={handleHover}
          onMouseLeave={handleHoverLeave}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
        >
          <CardContent>
            {loading === true ? (
              <LoopIcon
                sx={{
                  color: CustomPalette.GREY_300,
                  m: 2,
                  fontSize: "60px",
                  animation: spinningAnimation,
                  transition: "all 0.2s ease-in-out"
                }}
              />
            ) : dropDisabled === true ? (
              <CheckCircleOutlineIcon
                sx={{
                  m: 2,
                  fontSize: "60px",
                  color: CustomPalette.PRIMARY
                }}
              />
            ) : (
              <Tooltip title={t("Drag-and-Drop/Click-to-Find")} arrow>
                <Typography sx={{ fontSize: "16px", fontWeight: "700" }}>
                  {t("Upload Schema")}
                  <br />
                  {t("(.zip or .json for OCA)")}
                  <br />
                  {t("(.yaml or .yml for LinkML)")}
                </Typography>
              </Tooltip>
            )}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default LandingDropZone;
